import { leaveForPayment, markPaymentDeparture } from '../../../../helpers/shop/couponSession';

import MyPayPalProvider from "../Pago/PayPal/MyPayPalProvider";
import MPCheckoutPro from "../../../../helpers/mercadopago/MercadoPagoCheckoutPro";
// import EPHostedCheckout from "../../../../helpers/evopayments/EvoPaymentsHostedCheckout";

import { Box, Button } from "@mui/material";

const Payment = ({ paymentValues }) => {
    // referencias de pago
    const {
        payment_method, // método de pago
        order_id, nefro_reference,
        paypal_id, // PayPal
        preference_id, // MercadoPago
        redirect_url, // OpenPay
        // session_id, // EvoPayments
    } = paymentValues;

    // carga script MercadoPago
    MPCheckoutPro(preference_id);

    // helper EvoPayments
    // const [checkout, setCheckout] = useState(undefined);
    // carga script EvoPayments
    // EPHostedCheckout(session_id, setCheckout);

    // deshabilitar botón de OpenPay
    const disabled = false;

    // dirigirse a página de pago con EvoPayments
    // const evoPaymentsPage = () => {
    //     if (checkout) {
    //         // Tag Manager
    //         window.dataLayer.push({
    //             event: 'nefro-order'
    //         });
    //         checkout.showPaymentPage();
    //     } else basicMsg('No se ha cargado la página de pago');
    // };

    // compra con MercadoPago
    const mercadoPago = () => {
        markPaymentDeparture({ orderId: order_id, context: 'fast-checkout' });
        // notificar Tag Manager
        window.dataLayer.push({
            event: 'nefro-order'
        });
    };

    // redirigir al formulario de Openpay
    const openPay = () => {
        // setDisabled(true);
        // notificar Tag Manager
        window.dataLayer.push({
            event: 'nefro-order'
        });
        leaveForPayment(redirect_url, { orderId: order_id, context: 'fast-checkout' });
    };

    return (
        <Box sx={{ mt: 2 }}>
            {
                payment_method === 'PayPal' &&
                    <MyPayPalProvider
                        orderData={{
                            paypal_id, order_id, nefro_reference
                        }}
                    />
            }
            {
                payment_method === 'MercadoPago' &&
                    <div className="cho-container"
                        style={{ textAlign: 'center' }}
                        onClick={ mercadoPago }>
                    </div>
            }
            {/* {
                payment_method === 'EvoPayments' &&
                    <Button fullWidth
                        onClick={ evoPaymentsPage }
                        variant='contained'>Realizar pedido y pagar
                    </Button>
            } */}
            {/* EvoPayments embebido <div id="embed-target"></div> */}
            {
                payment_method === 'OpenPay' &&
                    <Button fullWidth
                        onClick={ openPay }
                        disabled={ disabled }
                        variant='contained'>Realizar pedido y pagar
                    </Button>
            }
        </Box>
    );
};

export default Payment;
